import React from 'react';
import { ButtonDiv } from '../styles/PayButton.styles';
import { Button, TypographyButton } from '@components/ModalButton.styles';

interface ButtonProps {
  handleNext: () => void;
  text: string;
  form?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean;
}

export function PayButton(props: ButtonProps) {
  const { handleNext, text, form, type, disabled } = props;
  return (
    <ButtonDiv>
      <Button onClick={handleNext} form={form} type={type} disabled={disabled}>
        <TypographyButton>{text}</TypographyButton>
      </Button>
    </ButtonDiv>
  );
}
